import React from 'react';

const AppFooter: React.FC = () => (
  <footer className="home-footer mt-auto" style={{ backgroundColor: '#000000' }}>
    <div className="container py-4">
      <div className="row g-4">
        <div className="col-12 col-md-6 col-lg-3">
          <h6 className="text-uppercase mb-3 text-white">Address</h6>
          <p className="text-muted small mb-0" style={{ color: 'rgba(255, 255, 255, 0.7)', lineHeight: '1.6' }}>
            FLAT-302<br />
            MARS PALACE<br />
            763 SWARGOLANE<br />
            WEST SHEWRAPARA MIRPUR,<br />
            DHAKA-1216<br />
            (METRO RAIL PILLAR 304)
          </p>
        </div>
        <div className="col-12 col-md-6 col-lg-3">
          <h6 className="text-uppercase mb-3 text-white">Contact Us</h6>
          <ul className="list-unstyled mb-0">
            <li className="mb-2" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              <small><strong>Phone Call:</strong></small>
              <br />
              <small>01788-083425</small>
            </li>
            <li className="mb-2" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              <small><strong>WhatsApp:</strong></small>
              <br />
              <small>01827-457573</small>
            </li>
            <li className="" style={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              <small><strong>Email:</strong></small>
              <br />
              <small>sportszonebd02@gmail.com</small>
            </li>
          </ul>
        </div>
        <div className="col-12 col-md-12 col-lg-3">
          <h6 className="text-uppercase mb-3 text-white">Follow Us</h6>
          <div className="d-flex gap-3 flex-wrap">
            <a href="https://www.facebook.com/share/1BycX1BtJZ/" target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary btn-sm rounded-circle" style={{ width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i className="bi bi-facebook" />
            </a>
            <a href="https://www.instagram.com/sportszonebd02?igsh=MXhmaXEweGRsbWIwMA==" target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary btn-sm rounded-circle" style={{ width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i className="bi bi-instagram" />
            </a>
            <a href="https://wa.me/8801827457573" target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary btn-sm rounded-circle" style={{ width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i className="bi bi-whatsapp" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default AppFooter;
